import { BillEvent } from './billEvent';
import { PaymentTransaction } from './paymentTransaction';

export interface BillData {
  apartmentId: string;
  apartmentName: string;
  travellers: {
    name: string;
    accommodationCost: number;
    skiPassCost: number;
    transportationCost: number;
    membershipFee: number;
    total: number;
  }[];
  totalAccommodation: number;
  totalSkiPass: number;
  totalTransportation: number;
  totalMembership: number;
  grandTotal: number;
  billStatus: string;
  isPaid: boolean;
}

export enum BillStatus {
  DRAFT = 'draft',
  GENERATED = 'generated', 
  SENT = 'sent',
  PARTIALLY_PAID = 'partially_paid',
  FULLY_PAID = 'fully_paid'
}

export interface Bill {
  id: string;
  tripId: string;
  apartmentId: string;
  apartmentName: string;
  
  // Bill content snapshot (immutable once generated)
  travellers: {
    id: string;
    name: string;
    accommodationCost: number;
    skiPassCost: number;
    transportationCost: number;
    membershipFee: number;
    total: number;
  }[];
  totalAccommodation: number;
  totalSkiPass: number;
  totalTransportation: number;
  totalMembership: number;
  grandTotal: number;
  
  // Bill metadata
  status: BillStatus;
  isPaid: boolean;
  paidAmount: number;
  generatedAt: Date;
  generatedBy: string; // User ID who generated the bill
  sentAt?: Date;
  paidAt?: Date;
  
  // Events timeline - chronological list of all bill events
  events: BillEvent[];
  
  // Payment transactions - detailed tracking of individual payments
  paymentTransactions: PaymentTransaction[];
  
  // Audit trail
  createdAt: Date;
  updatedAt: Date;
}

// Compatibility alias - to be removed after migration
export type PersistentBill = Bill;
